import React from "react";
import PropTypes from "prop-types";

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const isStringOrStringObject = (value) => typeof value === "string" || value instanceof String;

const useStyles = makeStyles((theme) => ({
  content: {
    padding: 0 + " !important",
  },
  buttonsContainer: {
    width: "100%",
    display: "flex",
    gap: theme.spacing(4),
  },
  button: theme.classes.mainButton,
  secondaryButton: theme.classes.secondaryButton,
  warningButton: theme.classes.warningButton,
}));

const CustomDialogContent = ({ dialogContent }) => {
  const classes = useStyles();
  if (isStringOrStringObject(dialogContent)) {
    return (
      <DialogContentText className={classes.content} id="alert-dialog-description">
        {dialogContent}
      </DialogContentText>
    );
  }
  return (
    <DialogContent className={classes.content} id="alert-dialog-description">
      {dialogContent}
    </DialogContent>
  );
};

CustomDialogContent.propTypes = {
  dialogContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

CustomDialogContent.defaultProps = {
  dialogContent: "",
};

const AlertDialog = ({
  openAlert,
  title,
  content,
  acceptButtonText,
  acceptButtonAction,
  cancelButtonText,
  disable,
  handleClose,
  warning,
}) => {
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={openAlert}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
        <DialogContent>
          <CustomDialogContent dialogContent={content} />
        </DialogContent>
        <DialogActions>
          <div className={classes.buttonsContainer}>
            <Button className={classes.secondaryButton} onClick={handleClose}>
              {cancelButtonText}
            </Button>
            {!!acceptButtonText && !!acceptButtonAction && (
              <Button
                className={warning ? classes.warningButton : classes.button}
                onClick={acceptButtonAction}
                disabled={disable}
              >
                {acceptButtonText}
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

AlertDialog.propTypes = {
  title: PropTypes.string,
  openAlert: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  acceptButtonText: PropTypes.string,
  acceptButtonAction: PropTypes.func,
  acceptButtonType: PropTypes.string,
  cancelButtonText: PropTypes.string,
  disable: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};

export default AlertDialog;
